const steppingStrategies = {
  STEP_WITH_CLOSURE: "Step With Closure",
  STEP_BY_STATE: "Step by Step",
  RANDOM: "Random Step",
};
export default steppingStrategies;
